export const ADD_SERVER_ERROR = 'ADD_SERVER_ERROR';
export const ADD_SERVER_SUCCESS = 'ADD_SERVER_SUCCESS';
export const START_GLOBAL_LOADER = 'START_GLOBAL_LOADER';
export const STOP_GLOBAL_LOADER = 'STOP_GLOBAL_LOADER';
export const COMPANY_FETCHED = 'COMPANY_FETCHED';
export const UPDATE_COMPANY_FILTERS = 'UPDATE_COMPANY_FILTERS';
export const UPDATE_LIST_FILTERS = 'UPDATE_LIST_FILTERS';
export const UPDATE_VERSION = 'UPDATE_VERSION';
export const APP_UPDATED = 'APP_UPDATED';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';

export const UPDATE_PRESENCE = 'UPDATE_PRESENCE';

export default {
  ADD_SERVER_ERROR,
  ADD_SERVER_SUCCESS,
  START_GLOBAL_LOADER,
  STOP_GLOBAL_LOADER,
  COMPANY_FETCHED,
  UPDATE_COMPANY_FILTERS,
  UPDATE_LIST_FILTERS,
  UPDATE_VERSION,
  APP_UPDATED,
  UPDATE_FILTERS,
  UPDATE_PRESENCE,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/mutation-types.js